module.exports = __webpack_public_path__ + "img/close-exam-view-btn.cdaa21a1.svg";